module.exports = __webpack_public_path__ + "media/images/solution-ussd-2bc64a86d7c1ad5732465d5911e510bd.png";